var ymapsPromise;
export function loadYmapsApi(options, mapApiKey) {
  if (!ymapsPromise) {
    ymapsPromise = new Promise(function (resolve, reject) {
      if (window.ymaps) {
        resolve(window.ymaps);
        return;
      }
      var e = window.document.createElement('script');
      e.src = "https://enterprise.api-maps.yandex.ru/2.1/?apikey=".concat(mapApiKey, "&lang=ru-RU&load=Map&coordorder=longlat");
      e.async = true;
      e.defer = true;
      e.onload = function () {
        resolve(window.ymaps);
      };
      e.onerror = function () {
        reject(new Error('Unable to load Yandex Maps API'));
      };
      window.document.body.appendChild(e);
    });
  }
  return ymapsPromise.then(function (ymaps) {
    return ymaps.ready(options).then(function () {
      return ymaps;
    });
  });
}